"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3982],{

/***/ 54392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ facebookIconBlue; },
/* harmony export */   "HM": function() { return /* binding */ googleIcon; },
/* harmony export */   "Ll": function() { return /* binding */ newChatIcon; },
/* harmony export */   "O4": function() { return /* binding */ removeIcon; },
/* harmony export */   "XT": function() { return /* binding */ newGoogleIcon; },
/* harmony export */   "_3": function() { return /* binding */ rightArrowIcon; },
/* harmony export */   "aq": function() { return /* binding */ stockbitIcon; },
/* harmony export */   "kn": function() { return /* binding */ adjustIcon; },
/* harmony export */   "pj": function() { return /* binding */ facebookIcon; },
/* harmony export */   "vq": function() { return /* binding */ successRegisterIcon; },
/* harmony export */   "wJ": function() { return /* binding */ pollingCloseIcon; }
/* harmony export */ });
/* unused harmony exports plusIcon, minusIcon, addPersonIcon, saveIcon, lockIcon, sortIcon, upIcon, downIcon, paperPlaneIcon */
var plusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC";
var minusIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==";
var addPersonIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAADhklEQVRo3uVa0W3iQBB9oPyHVICvgriDkAqgA7jvjBRSQbgOfNL8ByqIU0FMB9AB6QAq4H7eXkY+g9dk10TcShYysnf9PDNv3zzo7Pd7XMro4oLG1ak3ikgPQGq+Wqnq9pxgOk3STERGANxxXXHJB4ACwFxVi28JhiAyAP0Gc38AmLQJqluXSiKSA3g1QNYAngDcA7hR1Q6AG57/Igjw+ncRyc4eGdZEAeDWgJj6vGkRGQCYl17AIHZNdT2B/FbV1DdleF0KYMGvbgnuLGk2M0B+quq06cSqulXViQE0FJFZq2nGFHnn6YIP9KXBuhvy9IeqbtqKzMyw0TTQOhMAu9L8ccGISALgzi0aqmA5j2O1MWsyemRG/NypauiCzSrWaQVMHnohRmfJ00EbYBKnsyKldVFaJyqYfmQw/3cLICIpteHJYJJvhKcA8CoiaVMwrkDTSA/m5m1C+a7V6DUFs4rJNmbeVRs149jm1iesDXPfNnR5dDCqmpt+JLTscNJoraqtRAZGqg99WcQjKlMjk6I1a92KnXrGZgoA5l9NN97voryMIJNqqdmp3GsAxamAeF/BeXac9yxt8wTAixOeVNFZAyAzAM/m/kG5VqjS6/Y011s91bDg9qg7w0YtNyz0wZTJq9oDPtyIxd73ALJCtWUVx2rionNTwDAmxbakGspW1Bvtpu2BuecAxoGw7LxNQEZpatrfY2OBQEagiLgHvK+bz9ue5UQFu8TBAclT4Iw2bWOvmQ+ax9rFL7oFCB6ZUmo5sXhXcemSpLACULRtnl95iMOJZ9FbgEMAzyKyYzpmsfRYLRgyV4ZPV9PS8QrAhp9lak4YvZQ0fU3qHYvIkjS9aQ0MXfvHEoDs0EZZsz9NePQZtZWITGPps7/7DOsiN6kS7PcVSqPM7Pbeti831hGAtC6qls0yA2TBm4MUMCORGDU+9jXRCTr1Sc/Ofr8vi8ogZvmRN21N9PuQjNctdZXLmEBMexGlm+2SfvtmoaiDJOJA3IX0GrpGY61j0mZFDe1CO0GWANoWhxtfP6zJPrM1IZ9xt95GJICktCEHy4bOw8ND+cdYJ0FyWk8hAPTw+WcIK42CMqej5h6L8vGAeLQSBgA2VfXFYu7xSI28Kcuixp5C47a5QoKEHm8m6sFT+Zg7kxjZnx7o8Y+NtYlmKx1o55T/m5l0+oeh2qL3YGC+67iotvkPTTenKu8H9gUAAAAASUVORK5CYII=";
var saveIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9LnN0MXtmaWxsOm5vbmU7c3Ryb2tlOiMwMDAwMDA7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qye2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS1taXRlcmxpbWl0OjEwO30uc3Qze2ZpbGw6bm9uZTtzdHJva2U6IzAwMDAwMDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PHBhdGggZD0iTTExLDJoLTFIOEg3SDRIMnYxMmgyaDhoMlY1LjZMMTEsMnogTTksM3YzSDhWM0g5eiBNNywzdjNINVYzSDd6IE01LDEzdi0zaDZ2M0g1eiBNMTMsMTNoLTFWOUg0djRIM1YzaDF2NGgzaDFoMlYzaDAuNUwxMyw1LjlWMTN6Ii8+PC9zdmc+";
var newChatIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAACUklEQVRoQ+3ZwW3CMBQA0P+DyJkR2KBsUNigG5QjfB8KE7TdgErY4kY7QUeATlA6QbtB2xvi4upHGNFASIITxyCQOEASxe/72z92EM7kg2figJOBENEdAHQRsQUAc0R8HI/Hc9MRJwEhoikiduPZg4gdg/EeQkTcC9N9Q0Br/aaUavMx7yHcSCHEMwDc7sNIKSODl5DBYNBYrVYzAHhSSjEiCfMhpeQx4x/EIHhQa61/wzBsjkajnwTMUEo58g4SRwBAWym12E6prTR7kVJuJgBvUisNwcdNz/AEYFJuZ/olovf1HO2yRkZRTUMQUQsRZ1rrYRywAxFCaJcCAMiFAIAGAGwG905NMX8YiJnOXKCy9oRB1Ov1tkkvbyBFIv7NWi57pGhEJZAyEM4hZSGcQspEOIMci9hX+JJm001lL2uw2yD48T1rOSgVcixi/YAYFejKITYIbyC2CC8gRSAqhxSFqBRSJKIySNGISiBlICqBmJUlbxTE19hmZZdlPRGv2HkLtFVB7PV6zVqt9hk962zt+vFvG4TzHun3+zdBELzyjbXWizAMO7yCs0U4hxDRAyLem7RgTBAEQ60146I19qHl6aHltNPUIiLeFb9OaNDRCOc9IoT4Xkc+brFCOIWYgb6erXg3cM6pxd/JZPJluwvjLLW4fiyXy0YRjd6HdgaxjXja9RdI3gikRdT2eN72WFV228Z6U0cukAwRuKRW3ghkCKrVKXnbcxnsVuHOcLF1j2S4h9NTjtlp5Ae/K6etTL9Z4jvD+KXevJ5ONx0+42wgf0COBmCTeeVvAAAAAElFTkSuQmCC";
var stockbitIcon = "data:image/svg+xml;base64,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";
var adjustIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAYklEQVQ4y82UQQoAIAgEs/fuc/yvnYQoAyvJFrx4kB1XJBEpkaolWNNAAKZlqw9AtMIcMjO9Rd7VuIoagdtj5yAr1uoCjpDHNPMO25vm1UArzRzknTTdDr1p/ve+vKLvP3YDR+4tcGuq0dsAAAAASUVORK5CYII=";
var lockIcon = "data:image/svg+xml;utf8;base64,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";
var rightArrowIcon = "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI2OC44MzIgMjY4LjgzMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjY4LjgzMiAyNjguODMyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTI2NS4xNzEsMTI1LjU3N2wtODAtODBjLTQuODgxLTQuODgxLTEyLjc5Ny00Ljg4MS0xNy42NzgsMGMtNC44ODIsNC44ODItNC44ODIsMTIuNzk2LDAsMTcuNjc4bDU4LjY2MSw1OC42NjFIMTIuNSAgIGMtNi45MDMsMC0xMi41LDUuNTk3LTEyLjUsMTIuNWMwLDYuOTAyLDUuNTk3LDEyLjUsMTIuNSwxMi41aDIxMy42NTRsLTU4LjY1OSw1OC42NjFjLTQuODgyLDQuODgyLTQuODgyLDEyLjc5NiwwLDE3LjY3OCAgIGMyLjQ0LDIuNDM5LDUuNjQsMy42NjEsOC44MzksMy42NjFzNi4zOTgtMS4yMjIsOC44MzktMy42NjFsNzkuOTk4LTgwQzI3MC4wNTMsMTM4LjM3MywyNzAuMDUzLDEzMC40NTksMjY1LjE3MSwxMjUuNTc3eiIgZmlsbD0iIzZiNmI2YiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
var sortIcon = "data:image/gif;base64,R0lGODlhFQAJAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw==";
var upIcon = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7";
var downIcon = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7";
var googleIcon = "data:image/svg+xml;base64,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";
var newGoogleIcon = "data:image/svg+xml;base64,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";
var facebookIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA5LjMgMTgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDkuMyAxODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6I0ZGRkZGRjt9DQo8L3N0eWxlPg0KPHBhdGggaWQ9ImYiIGNsYXNzPSJzdDAiIGQ9Ik02LjEsMThWOS44aDIuOGwwLjQtMy4ySDYuMXYtMkM2LjEsMy42LDYuMywzLDcuNywzbDEuNywwVjAuMUM5LjEsMC4xLDgsMCw2LjksMEM0LjQsMCwyLjgsMS41LDIuOCw0LjINCgl2Mi40SDB2My4yaDIuOFYxOEg2LjF6Ii8+DQo8L3N2Zz4NCg==";
var facebookIconBlue = "data:image/png;base64,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";
var paperPlaneIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiM2QjZCNkI7fTwvc3R5bGU+PGc+PGc+PHBhdGggY2xhc3M9InN0MCIgZD0iTTE5Ny4xLDguNGMtMC4xLTAuNS0wLjMtMC45LTAuNS0xLjNjMC0wLjEtMC4xLTAuMi0wLjEtMC4zYzAtMC4xLTAuMS0wLjEtMC4yLTAuMmMtMC4yLTAuMi0wLjQtMC40LTAuNi0wLjZjLTAuMi0wLjEtMC4zLTAuMy0wLjUtMC40Yy0wLjEsMC0wLjEtMC4xLTAuMi0wLjJjLTAuMSwwLTAuMy0wLjEtMC41LTAuMmMtMC4yLTAuMS0wLjQtMC4yLTAuNi0wLjJjLTAuMywwLTAuNS0wLjEtMC44LTAuMWMtMC4yLDAtMC40LDAtMC42LDBjLTAuMywwLTAuNiwwLjEtMC44LDAuMmMtMC4xLDAtMC4zLDAtMC40LDAuMUw1LjQsODUuNmMtMi4yLDAuOS0zLjEsMy40LTIuMiw1LjZjMC40LDAuOSwxLjEsMS43LDIuMSwyLjJsNjkuNCwzMi42djY0LjljMCwyLjMsMS45LDQuMiw0LjIsNC4yYzEuNSwwLDIuOC0wLjgsMy42LTJsMjkuMy00Ny43bDQ1LjMsMjMuOWMyLjEsMS4xLDQuNiwwLjMsNS43LTEuOGMwLjItMC4zLDAuMy0wLjcsMC40LTEuMUwxOTcsMTAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTAuMywwLTAuNSwwLjEtMC43QzE5Ny4xLDguOSwxOTcuMSw4LjcsMTk3LjEsOC40eiBNNzgsMTE4LjFMMTcuNSw4OS42bDE1Ni44LTY3LjdMNzgsMTE4LjF6IE04My4xLDE3NS44di00NS42bDIxLjIsMTEuMkw4My4xLDE3NS44eiBNMTU2LjEsMTU5LjFsLTM5LjktMjFsLTcuMi00LjRsLTAuMywwLjVsLTIyLjgtMTJsOTkuNy05OS44TDE1Ni4xLDE1OS4xeiIvPjwvZz48L2c+PC9zdmc+";
var removeIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYgMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNGRjZFNkU7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik04LjQsMC44QzQuMywwLjgsMSw0LjEsMSw4LjFzMy4zLDcuNCw3LjQsNy40czcuNC0zLjMsNy40LTcuNFMxMi40LDAuOCw4LjQsMC44eiBNMTEuMSw4LjZINS42VjcuN2g1LjVWOC42eiINCgkvPg0KPC9zdmc+DQo=";
var pollingCloseIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMi4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNFOUU5RTk7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0yMCw5LjlDMTkuOSw0LjQsMTUuNC0wLjEsOS45LDBDNC40LDAuMS0wLjEsNC42LDAsMTAuMWMwLjEsNS41LDQuNiwxMCwxMC4xLDkuOUMxNS42LDE5LjksMjAuMSwxNS40LDIwLDkuOXoNCgkgTTEyLjgsMTMuNUwxMCwxMC43bC0yLjgsMi44bC0wLjctMC43TDkuMywxMEw2LjUsNy4ybDAuNy0wLjdMMTAsOS4zbDIuOC0yLjhsMC43LDAuN0wxMC43LDEwbDIuOCwyLjhMMTIuOCwxMy41eiIvPg0KPC9zdmc+DQo=";
var successRegisterIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjAwIDIwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAwIDIwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiM2QjZCNkI7fTwvc3R5bGU+PGc+PGc+PHBhdGggY2xhc3M9InN0MCIgZD0iTTE5Ny4xLDguNGMtMC4xLTAuNS0wLjMtMC45LTAuNS0xLjNjMC0wLjEtMC4xLTAuMi0wLjEtMC4zYzAtMC4xLTAuMS0wLjEtMC4yLTAuMmMtMC4yLTAuMi0wLjQtMC40LTAuNi0wLjZjLTAuMi0wLjEtMC4zLTAuMy0wLjUtMC40Yy0wLjEsMC0wLjEtMC4xLTAuMi0wLjJjLTAuMSwwLTAuMy0wLjEtMC41LTAuMmMtMC4yLTAuMS0wLjQtMC4yLTAuNi0wLjJjLTAuMywwLTAuNS0wLjEtMC44LTAuMWMtMC4yLDAtMC40LDAtMC42LDBjLTAuMywwLTAuNiwwLjEtMC44LDAuMmMtMC4xLDAtMC4zLDAtMC40LDAuMUw1LjQsODUuNmMtMi4yLDAuOS0zLjEsMy40LTIuMiw1LjZjMC40LDAuOSwxLjEsMS43LDIuMSwyLjJsNjkuNCwzMi42djY0LjljMCwyLjMsMS45LDQuMiw0LjIsNC4yYzEuNSwwLDIuOC0wLjgsMy42LTJsMjkuMy00Ny43bDQ1LjMsMjMuOWMyLjEsMS4xLDQuNiwwLjMsNS43LTEuOGMwLjItMC4zLDAuMy0wLjcsMC40LTEuMUwxOTcsMTAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTAuMywwLTAuNSwwLjEtMC43QzE5Ny4xLDguOSwxOTcuMSw4LjcsMTk3LjEsOC40eiBNNzgsMTE4LjFMMTcuNSw4OS42bDE1Ni44LTY3LjdMNzgsMTE4LjF6IE04My4xLDE3NS44di00NS42bDIxLjIsMTEuMkw4My4xLDE3NS44eiBNMTU2LjEsMTU5LjFsLTM5LjktMjFsLTcuMi00LjRsLTAuMywwLjVsLTIyLjgtMTJsOTkuNy05OS44TDE1Ni4xLDE1OS4xeiIvPjwvZz48L2c+PC9zdmc+";


/***/ }),

/***/ 62582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ modalUnavailableStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var modalUnavailableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        show: function() {
            set({
                visible: true
            });
        },
        hide: function() {
            set({
                visible: false
            });
        }
    };
});



/***/ }),

/***/ 54855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AUTH_MODAL_CONFIG; },
/* harmony export */   "q": function() { return /* binding */ AUTH_ORDER_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);

var AUTH_ORDER_TYPE = {
    BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
    SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
    AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
    AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
};
var AUTH_MODAL_CONFIG = {
    real: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
    },
    virtual: {
        BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_BUY */ .Jm.VIRTUAL_BUY,
        SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_SELL */ .Jm.VIRTUAL_SELL,
        AMEND_BUY: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_BUY */ .Jm.VIRTUAL_AMEND_BUY,
        AMEND_SELL: constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.VIRTUAL_AMEND_SELL */ .Jm.VIRTUAL_AMEND_SELL
    }
};


/***/ }),

/***/ 70175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useAuthModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        tradingModalConfig: null,
        showModal: function() {
            var tradingModalConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            set({
                tradingModalConfig: tradingModalConfig,
                visible: true
            });
        },
        closeModal: function() {
            set({
                tradingModalConfig: null,
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useAuthModalStore);


/***/ }),

/***/ 47756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input_SearchInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
;// CONCATENATED MODULE: ./src/global/Icons/SearchSvg.tsx

var SearchSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.75 8.75C3.75 6.26472 5.76472 4.25 8.25 4.25C10.7353 4.25 12.75 6.26472 12.75 8.75C12.75 11.2353 10.7353 13.25 8.25 13.25C5.76472 13.25 3.75 11.2353 3.75 8.75ZM8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75C9.63653 14.75 10.9132 14.2797 11.9292 13.4899L14.4697 16.0303C14.7626 16.3232 15.2374 16.3232 15.5303 16.0303C15.8232 15.7374 15.8232 15.2626 15.5303 14.9697L12.9899 12.4292C13.7797 11.4132 14.25 10.1365 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ var Icons_SearchSvg = (SearchSvg);

;// CONCATENATED MODULE: ./src/global/Icons/CloseIconCircleSvg.tsx

var CloseIconCircleSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fillRule: "evenodd",
        viewBox: "64 64 896 896",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
        })
    });
};
/* harmony default export */ var Icons_CloseIconCircleSvg = (CloseIconCircleSvg);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 8 modules
var input = __webpack_require__(7648);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Input/SearchInput/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 12px;\n  border-radius: 4px;\n\n  &.ant-input-affix-wrapper {\n    border-color: #ededed;\n\n    &.ant-input-affix-wrapper-focused {\n      border-color: #00ab6b;\n    }\n  }\n\n  font-size: 14px;\n  line-height: 19px;\n\n  & .ant-input-prefix {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Input = (0,styled_components_browser_esm["default"])(input/* default */.Z).withConfig({
    componentId: "sc-d336921a-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/global/Input/SearchInput/index.tsx









var SearchInput = function(_param) {
    var onClear = _param.onClear, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClear"
    ]);
    var ref = (0,react.useState)(props.value || ""), value = ref[0], setValue = ref[1];
    var inputValue = props.value || value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            component: Icons_SearchSvg,
            style: {
                fontSize: 18,
                color: "#969696"
            }
        }),
        suffix: onClear && inputValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            onClick: function() {
                setValue("");
                onClear();
            },
            component: Icons_CloseIconCircleSvg,
            style: {
                fontSize: 16,
                color: "#969696"
            }
        }) : undefined
    }, props), {
        onChange: function(e) {
            var ref;
            setValue(e.target.value);
            (ref = props.onChange) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        value: inputValue
    }));
};
/* harmony default export */ var Input_SearchInput = (SearchInput);


/***/ }),

/***/ 5728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ tradingErrorModalList; },
/* harmony export */   "c0": function() { return /* binding */ tradingErrorModalConfig; },
/* harmony export */   "qO": function() { return /* binding */ errorInfoList; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var errorInfoList = [
    {
        error: 401,
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama",
        isLogoutUser: true
    },
    {
        error: 500,
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        isShowButton: true,
        buttonText: "Tutup"
    },
    {
        error: 503,
        imageUrl: "/img/maintenance-mode.svg",
        title: "Maintenance Sedang Berlangsung",
        description: "Stockbit sedang menjalankan maintenance, cobalah beberapa saat lagi.",
        isShowButton: true,
        buttonText: "Kembali ke Halaman Utama"
    }, 
];
var tradingErrorModalConfig = {
    sessionExpired: {
        imageUrl: "/img/session-time-out.svg",
        title: "Sesi Kamu Sudah Habis",
        description: "Silahkan login kembali untuk melanjutkan",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: true,
        isLogoutUser: true
    },
    maintenance: {
        imageUrl: "/img/maintenance-mode.svg",
        title: "Pemeliharaan Sedang Berlangsung",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    dailyMaintenance: {
        imageUrl: "/img/daily-maintenance.svg",
        title: "Persiapan Harian",
        buttonText: "Kembali ke Halaman Utama",
        isShowButton: false
    },
    systemError: {
        imageUrl: "/img/internal-server-error.svg",
        title: "Kendala pada Server",
        description: "Jangan khawatir, tim kami sedang memperbaikinya. Silakan coba lagi nanti.",
        buttonText: "Tutup",
        isShowButton: true
    },
    userSuspend: {
        imageUrl: "/img/trading-limit-user-suspended.svg",
        title: "Tidak Dapat Melakukan Transaksi",
        description: "Deposit atau jual saham untuk melakukan transaksi.",
        buttonText: "Deposit Sekarang",
        isShowButton: true,
        redirectTo: "/securities/deposit",
        needToCloseTradingModal: true,
        isFullWidthButton: true
    }
};
var tradingErrorModalList = {
    401: {
        NO_SERVER_RESPONSE: "sessionExpired",
        INVALID_AUTH: "sessionExpired",
        // checkov:skip=<CKV_SECRET_6> "false positive, no secret TOKEN exposed here"
        INVALID_TOKEN: "sessionExpired",
        INVALID_SESSION: "sessionExpired",
        MOCK_TRADING: "sessionExpired",
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance",
        UNAUTHORIZED: "sessionExpired"
    },
    403: {
        USER_SUSPEND: "userSuspend"
    },
    503: {
        MAINTENANCE_MODE: "maintenance",
        DAILY_MAINTENANCE_MODE: "dailyMaintenance"
    },
    500: {
        SYSTEM_ERROR: "systemError"
    }
};


/***/ }),

/***/ 6474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ getCashInfo; },
  "S": function() { return /* binding */ getCashOnHand; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/global/Securities/constants/apiEndpoints/balance.ts
var balanceEndpoint = {
    cashInfo: "/balance/cash/info",
    cashOnHand: "/balance/cash"
};
/* harmony default export */ var balance = (balanceEndpoint);

// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/balance.ts




var getCashInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode, orderId) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashInfo, {
                        params: {
                            stock_code: stockCode,
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashInfo(stockCode, orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getCashOnHand = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,trading/* getTradingApiInstance */.j)().get(balance.cashOnHand));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCashOnHand() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 64924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ getBondPortfolioDetail; },
/* harmony export */   "OF": function() { return /* binding */ postBondSell; },
/* harmony export */   "QY": function() { return /* binding */ getBondSellPreview; },
/* harmony export */   "R0": function() { return /* binding */ getBondOrderList; },
/* harmony export */   "UU": function() { return /* binding */ getBondBuyPreview; },
/* harmony export */   "iC": function() { return /* binding */ getBondOrderDetail; },
/* harmony export */   "yr": function() { return /* binding */ getBondPortfolioList; },
/* harmony export */   "yt": function() { return /* binding */ postBondBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96563);




var postBondBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postBuy */ .EN.postBuy, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondBuy(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondBuyPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getBuyPreview */ .EN.getBuyPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondBuyPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var postBondSell = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postSell */ .EN.postSell, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondSell(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondSellPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getSellPreview */ .EN.getSellPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondSellPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderList */ .EN.getOrderList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderDetail */ .EN.getOrderDetail(orderId)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioList */ .EN.getPortfolioList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        var withCouponHistories, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withCouponHistories = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioDetail */ .EN.getPortfolioDetail(orderId), {
                        params: {
                            with_coupon_histories: withCouponHistories ? 1 : 0
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16311);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 75626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ OrderStatus; },
/* harmony export */   "i": function() { return /* binding */ OrderAction; }
/* harmony export */ });
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));


/***/ }),

/***/ 91037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IC": function() { return /* binding */ OrderSecuritiesKindType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "l5": function() { return /* binding */ ForcedSellMapper; },
/* harmony export */   "oU": function() { return /* binding */ OrderSide; },
/* harmony export */   "pD": function() { return /* binding */ OrderForceSellType; },
/* harmony export */   "pY": function() { return /* binding */ SecuritiesKind; },
/* harmony export */   "vT": function() { return /* binding */ iOrderSide; }
/* harmony export */ });
/* unused harmony exports OrderStatus, LeverageType */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var SecuritiesKind;
(function(SecuritiesKind) {
    SecuritiesKind[SecuritiesKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SecuritiesKind[SecuritiesKind["STOCK"] = 1] = "STOCK";
    SecuritiesKind[SecuritiesKind["BOND"] = 2] = "BOND";
})(SecuritiesKind || (SecuritiesKind = {}));
var OrderSecuritiesKindType;
(function(OrderSecuritiesKindType) {
    OrderSecuritiesKindType["Unspecified"] = "SECURITIES_KIND_UNSPECIFIED";
    OrderSecuritiesKindType["Stock"] = "SECURITIES_KIND_STOCK";
    OrderSecuritiesKindType["Bond"] = "SECURITIES_KIND_BOND";
})(OrderSecuritiesKindType || (OrderSecuritiesKindType = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var iOrderSide;
(function(iOrderSide) {
    iOrderSide[iOrderSide["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    iOrderSide[iOrderSide["BUY"] = 1] = "BUY";
    iOrderSide[iOrderSide["SELL"] = 2] = "SELL";
})(iOrderSide || (iOrderSide = {}));
var OrderSide;
(function(OrderSide) {
    OrderSide["Unspecified"] = "SIDE_UNSPECIFIED";
    OrderSide["Buy"] = "SIDE_BUY";
    OrderSide["Sell"] = "SIDE_SELL";
})(OrderSide || (OrderSide = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));
var OrderForceSellType;
(function(OrderForceSellType) {
    OrderForceSellType["Unspecified"] = "DAY_TRADE_FORCE_SELL_UNSPECIFIED";
    OrderForceSellType["DebtRatio"] = "DAY_TRADE_FORCE_SELL_DEBT_RATIO";
    OrderForceSellType["TimeLimit"] = "DAY_TRADE_FORCE_SELL_TIME_LIMIT";
})(OrderForceSellType || (OrderForceSellType = {}));
var LeverageType;
(function(LeverageType) {
    LeverageType["Unspecified"] = "LEVERAGE_TYPE_TRADING_UNSPECIFIED";
    LeverageType["TradingBalance"] = "LEVERAGE_TYPE_TRADING_BALANCE";
    LeverageType["TradingLimit"] = "LEVERAGE_TYPE_TRADING_LIMIT";
    LeverageType["BasicLimit"] = "LEVERAGE_TYPE_BASIC_LIMIT";
    LeverageType["TempLimit"] = "LEVERAGE_TYPE_TEMP_LIMIT";
    LeverageType["DayTrade"] = "LEVERAGE_TYPE_DAY_TRADE";
})(LeverageType || (LeverageType = {}));
var _obj;
var ForcedSellMapper = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.DebtRatio, "FORCED SELL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.TimeLimit, "FORCED SELL"), _obj);


/***/ }),

/***/ 38525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ withMaintenanceGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/maintenance.ts




var getMaintenanceStatus = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* maintenanceEndpoint.getStatus */.bB.getStatus, {
                        withAccessToken: false
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMaintenanceStatus() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/types/api/maintenance.ts
var MaintenanceStatusType;
(function(MaintenanceStatusType) {
    MaintenanceStatusType["Unspecified"] = "STATUS_UNSPECIFIED";
    MaintenanceStatusType["OnMaintenance"] = "STATUS_MAINTENANCE";
    MaintenanceStatusType["NotMaintenance"] = "STATUS_NOT_MAINTENANCE";
})(MaintenanceStatusType || (MaintenanceStatusType = {}));

;// CONCATENATED MODULE: ./src/global/Securities/utils/maintenance.ts





// Modify the function signature to accept arguments
function withMaintenanceGuard(// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
    return _withMaintenanceGuard.apply(this, arguments);
}
function _withMaintenanceGuard() {
    _withMaintenanceGuard = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callback) {
        var isAllowed, response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isAllowed = false;
                    if (isAllowed) {
                        _ctx.next = 4;
                        break;
                    }
                    return _ctx.abrupt("return", callback());
                case 4:
                    _ctx.next = 6;
                    return getMaintenanceStatus();
                case 6:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, message = _data.message;
                    if (!(data.status === MaintenanceStatusType.OnMaintenance)) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", trading/* default.getState */.Z.getState().setErrorCode(503, message, "DAILY_MAINTENANCE_MODE"));
                case 10:
                    return _ctx.abrupt("return", callback());
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", callback());
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return _withMaintenanceGuard.apply(this, arguments);
}


/***/ }),

/***/ 29541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useBondOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);






var initialState = {
    selected: undefined,
    list: [],
    isLoading: false,
    isLoadingList: false
};
var useBondOrder = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetails: function loadOrderDetails(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var list, index, response, _data, order;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            list = get().list;
                            index = list.findIndex(function(data) {
                                return data.id === id;
                            });
                            if (!(index >= 0)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                selected: list[index],
                                isLoading: false
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderDetail */ .iC)(id);
                        case 9:
                            response = _ctx.sent;
                            _data = response.data, order = _data.data.order;
                            set({
                                selected: order,
                                isLoading: false
                            });
                            _ctx.next = 18;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        loadOrderList: function loadOrderList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, _data, orders;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondOrderList */ .R0)();
                        case 4:
                            response = _ctx.sent;
                            _data = response.data, orders = _data.data.orders;
                            set({
                                list: orders,
                                isLoadingList: false
                            });
                            _ctx.next = 13;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false
                            });
                            Promise.reject(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        },
        clearSelected: function clearSelected() {
            set({
                selected: null
            });
        },
        clearList: function clearList() {
            set({
                list: []
            });
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 29176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondPortfolioStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75413);








var initialState = {
    detailBySymbol: undefined,
    details: undefined,
    portfolios: [],
    bondPortfolioState: [],
    transactions: [],
    product: undefined,
    couponHistories: undefined,
    isLoading: false,
    isLoadingList: false
};
var useBondPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadPortfolioList: function loadPortfolioList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, portfolios, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioList */ .yr)();
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            portfolios = data.portfolios, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "portfolios"
                            ]);
                            set({
                                portfolios: portfolios,
                                bondPortfolioState: portfolios.map(utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].portfolioItemFromBonds */ .Z.portfolioItemFromBonds),
                                details: rest,
                                isLoadingList: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false,
                                portfolios: initialState.portfolios,
                                details: initialState.details,
                                bondPortfolioState: initialState.bondPortfolioState
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        loadPortfolioDetails: function loadPortfolioDetails(id) {
            var withCouponHistories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, transactions, coupon_histories, product, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioDetail */ .IE)(id, withCouponHistories);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            transactions = data.transactions, coupon_histories = data.coupon_histories, product = data.product, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "transactions",
                                "coupon_histories",
                                "product"
                            ]);
                            set({
                                transactions: transactions,
                                product: product,
                                couponHistories: coupon_histories,
                                detailBySymbol: rest,
                                isLoading: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        },
        clearPortfolioList: function clearPortfolioList() {
            set({
                portfolios: initialState.portfolios,
                transactions: initialState.transactions,
                product: initialState.product
            });
        },
        clearAssets: function clearAssets() {
            set({
                transactions: initialState.transactions,
                detailBySymbol: initialState.detailBySymbol
            });
        }
    });
});


/***/ }),

/***/ 42427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useBondPreviewStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);







var initialState = {
    buy: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialBuyPreview */ .dX,
    sell: _constants__WEBPACK_IMPORTED_MODULE_2__/* .initialSellPreview */ .Bv,
    product: undefined,
    isLoading: false
};
var useBondPreviewStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadBuyPreview: /**
   * We override the response when receive unit value <= 0
   *
   * This behavior is needed to provide the initial value of the buy modal
   *
   * We will show the 0 values to the user,
   *    except the buy price `price_rate` value.
   *
   */ function loadBuyPreview(productId) {
            var unit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().buy.price_rate;
                            if (!(isZeroUnit && priceRate)) {
                                _ctx.next = 6;
                                break;
                            }
                            set({
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: priceRate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 6:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondBuyPreview */ .UU)({
                                product_id: productId,
                                /**
         * We will set the unit to 1 if the unit is 0 or negative value
         * So it will still calls the API without any errors
         */ unit: isZeroUnit ? 1 : unit
                            });
                        case 9:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 14;
                                break;
                            }
                            set({
                                // we store the product information
                                product: data.product,
                                isLoading: false,
                                // override response
                                buy: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.buy), {
                                    // exception, price_rate is needed to show the buying price
                                    price_rate: data.price_rate
                                })
                            });
                            return _ctx.abrupt("return");
                        case 14:
                            set({
                                buy: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 21;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                product: initialState.product,
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadSellPreview: function loadSellPreview(productId, acquisitionOrderId) {
            var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isZeroUnit, priceRate, availableUnit, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isZeroUnit = unit <= 0;
                            priceRate = get().sell.price.sell;
                            availableUnit = get().sell.available_units;
                            if (!(isZeroUnit && priceRate && availableUnit)) {
                                _ctx.next = 7;
                                break;
                            }
                            set({
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    available_units: availableUnit,
                                    // exception, price.sell is needed to show the selling price
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        sell: priceRate
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            if (productId) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error("Product Code is required");
                        case 9:
                            if (acquisitionOrderId) {
                                _ctx.next = 11;
                                break;
                            }
                            throw new Error("Order id is required");
                        case 11:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 14;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondSellPreview */ .QY)({
                                product_id: productId,
                                acquisition_order_id: acquisitionOrderId,
                                unit: isZeroUnit ? 1 : unit
                            });
                        case 14:
                            response = _ctx.sent;
                            data = response.data.data;
                            if (!isZeroUnit) {
                                _ctx.next = 19;
                                break;
                            }
                            set({
                                product: data.product,
                                isLoading: false,
                                // override the sell preview response with initial state
                                sell: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell), {
                                    // exception, available unit
                                    available_units: data.available_units,
                                    price: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState.sell.price), {
                                        // except the price sell data
                                        sell: data.price.sell
                                    })
                                })
                            });
                            return _ctx.abrupt("return");
                        case 19:
                            set({
                                sell: data,
                                product: data.product,
                                isLoading: false
                            });
                            _ctx.next = 26;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 26:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 55847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useBondTransaction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73921);
/* harmony import */ var _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78311);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42427);









var initialState = {
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    productId: "",
    unit: 0,
    acquisitionOrderId: "",
    priceRate: 0,
    isLoading: false,
    isTnCAccepted: false,
    isSuccess: false
};
var useBondTransaction = (0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialState), {
        submitOrder: function submitOrder() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, isTnCAccepted, transactionType, acquisitionOrderId, buy, sell, ref1, clearTransaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            ref = get(), isTnCAccepted = ref.isTnCAccepted, transactionType = ref.transactionType, acquisitionOrderId = ref.acquisitionOrderId;
                            if (isTnCAccepted) {
                                _ctx.next = 5;
                                break;
                            }
                            throw new Error("Terms and Condition is required");
                        case 5:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY)) {
                                _ctx.next = 9;
                                break;
                            }
                            buy = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().buy;
                            _ctx.next = 9;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondBuy */ .yt)({
                                price_rate: buy.price_rate,
                                product_id: buy.product.id,
                                unit: parseInt(buy.unit, 10)
                            });
                        case 9:
                            if (!(transactionType === global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL)) {
                                _ctx.next = 13;
                                break;
                            }
                            sell = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().sell;
                            _ctx.next = 13;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .postBondSell */ .OF)({
                                product_id: sell.product.id,
                                buy_order_id: acquisitionOrderId,
                                unit: sell.units,
                                price_rate: sell.price.sell
                            });
                        case 13:
                            // inform the ui layer that the transaction is success
                            set({
                                isLoading: false,
                                isSuccess: true
                            });
                            ref1 = get(), clearTransaction = ref1.clearData;
                            clearTransaction(); // transaction states
                            _ctx.next = 22;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                isSuccess: false
                            });
                            Promise.reject(_ctx.t0);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }))();
        },
        clearData: function clearData() {
            set(initialState);
        },
        setTnC: function setTnC(value) {
            set({
                isTnCAccepted: value
            });
        },
        initiateBuyTransaction: function initiateBuyTransaction(productId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadBuyPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadBuyPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadBuyPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.BUY */ .qB.BUY
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadBuyPreview(productId)
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        initiateSellTransaction: function initiateSellTransaction(productId, acquisitionOrderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadSellPreview, loadBalance;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadSellPreview = _useBondPreview__WEBPACK_IMPORTED_MODULE_4__/* .useBondPreviewStore.getState */ .d.getState().loadSellPreview;
                            loadBalance = _useCashOnHandStore__WEBPACK_IMPORTED_MODULE_3__/* .useCashOnHandStore.getState */ .I.getState().loadBalance;
                            set({
                                acquisitionOrderId: acquisitionOrderId,
                                productId: productId,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_2__/* .BondTransactionActionEnum.SELL */ .qB.SELL
                            });
                            _ctx.next = 5;
                            return Promise.all([
                                loadBalance(),
                                loadSellPreview(productId, acquisitionOrderId, 1), 
                            ]);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    });
});


/***/ }),

/***/ 81557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useBondsModalStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73921);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);
/* harmony import */ var _useBondOrder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29541);
/* harmony import */ var _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29176);
/* harmony import */ var _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55847);
/* harmony import */ var _useBondPreview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42427);












var initialState = {
    isLoading: false,
    error: undefined,
    isSearchActive: false,
    isAllowedToSearch: false,
    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED,
    transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.UNSPECIFIED */ .qB.UNSPECIFIED,
    blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.UNSPECIFIED */ .Ew.UNSPECIFIED
};
var useBondsModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, initialState), {
        toggleSearch: function toggleSearch(state) {
            if (typeof state === "boolean") {
                set({
                    isSearchActive: state
                });
                return;
            }
            set(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prev), {
                    isSearchActive: !prev.isSearchActive
                });
            });
        },
        openConfirmModal: function openConfirmModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
            });
        },
        openBlockerModal: function openBlockerModal(blockerType) {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                blockerType: blockerType
            });
        },
        openTncModal: function openTncModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC
            });
        },
        openCouponReceipt: function openCouponReceipt(orderId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, couponHistories, loadPortfolioDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState(), couponHistories = ref.couponHistories, loadPortfolioDetails = ref.loadPortfolioDetails;
                            if (couponHistories) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return loadPortfolioDetails(orderId, true);
                        case 4:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.COUPON_RECEIPT */ ._y.COUPON_RECEIPT
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderModal: function openOrderModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER */ ._y.ORDER
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openOrderHistoryModal: function openOrderHistoryModal(id) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var loadOrderDetails;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadOrderDetails = _useBondOrder__WEBPACK_IMPORTED_MODULE_3__/* .useBondOrder.getState */ .o.getState().loadOrderDetails;
                            _ctx.next = 3;
                            return loadOrderDetails(id);
                        case 3:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.HISTORY */ ._y.HISTORY
                            });
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        openBuyModal: function openBuyModal(productId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateBuyTransaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            initiateBuyTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateBuyTransaction;
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.BUY */ .qB.BUY,
                                isAllowedToSearch: true,
                                sourcePage: sourcePage
                            });
                            _ctx.next = 5;
                            return initiateBuyTransaction(productId);
                        case 5:
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }))();
        },
        openSellModal: function openSellModal(productId, orderId, sourcePage) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var initiateSellTransaction, loadPortfolioDetails, transactions, _transactions, transaction;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            // store the source page
                            if (sourcePage) {
                                set({
                                    sourcePage: sourcePage
                                });
                            }
                            if (!orderId) {
                                _ctx.next = 8;
                                break;
                            }
                            initiateSellTransaction = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().initiateSellTransaction;
                            _ctx.next = 6;
                            return initiateSellTransaction(productId, orderId);
                        case 6:
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION,
                                transactionType: global_Securities_types_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .BondTransactionActionEnum.SELL */ .qB.SELL,
                                isAllowedToSearch: false
                            });
                            return _ctx.abrupt("return");
                        case 8:
                            loadPortfolioDetails = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().loadPortfolioDetails;
                            _ctx.next = 11;
                            return loadPortfolioDetails(productId);
                        case 11:
                            transactions = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().transactions;
                            if (!(transactions.length === 1)) {
                                _ctx.next = 19;
                                break;
                            }
                            _transactions = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(transactions, 1), transaction = _transactions[0];
                            if (!transaction.is_stable_earn) {
                                _ctx.next = 17;
                                break;
                            }
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.BLOCKERS */ ._y.BLOCKERS,
                                blockerType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondBlockerType.STABLE_EARN */ .Ew.STABLE_EARN
                            });
                            return _ctx.abrupt("return");
                        case 17:
                            get().openSellModal(productId, transaction.order_code);
                            return _ctx.abrupt("return");
                        case 19:
                            // open the assets / product selection modal
                            set({
                                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ASSETS */ ._y.ASSETS
                            });
                            _ctx.next = 25;
                            break;
                        case 22:
                            _ctx.prev = 22;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 25:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        22
                    ]
                ]);
            }))();
        },
        openOrderPlacedModal: function openOrderPlacedModal() {
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.ORDER_PLACED */ ._y.ORDER_PLACED
            });
        },
        closeModal: function closeModal() {
            var ref = get(), modalType = ref.modalType, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            if (isSearchActive) {
                toggleSearch();
            }
            if (modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TNC */ ._y.TNC) {
                // back to confirmation
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION
                });
                return;
            }
            // back to the transaction
            var product = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState().product;
            var isBackToTransaction = modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.CONFIRMATION */ ._y.CONFIRMATION;
            if (isBackToTransaction && product) {
                set({
                    modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION
                });
                return;
            }
            // Close the modal
            set({
                modalType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.UNSPECIFIED */ ._y.UNSPECIFIED
            });
        },
        closeTransactionModal: function closeTransactionModal() {
            var ref = get(), closeModal = ref.closeModal, toggleSearch = ref.toggleSearch, isSearchActive = ref.isSearchActive;
            var clearData = _useBondTransaction__WEBPACK_IMPORTED_MODULE_5__/* .useBondTransaction.getState */ .P.getState().clearData;
            var ref1 = _useBondPreview__WEBPACK_IMPORTED_MODULE_6__/* .useBondPreviewStore.getState */ .d.getState(), clearPreview = ref1.clear;
            var clearPortfolioList = _useBondPortfolioStore__WEBPACK_IMPORTED_MODULE_4__/* .useBondPortfolioStore.getState */ .Z.getState().clearPortfolioList;
            if (isSearchActive) {
                toggleSearch();
            }
            clearPreview();
            clearPortfolioList();
            clearData();
            closeModal();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 78311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useCashOnHandStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6474);






var initialState = {
    cashOnHand: 0,
    isLoading: false
};
var useCashOnHandStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadBalance: function loadBalance() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,global_Securities_api_balance__WEBPACK_IMPORTED_MODULE_1__/* .getCashOnHand */ .S)();
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            set({
                                cashOnHand: data.available_cash_on_hand
                            });
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        }
    });
});


/***/ }),

/***/ 70362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* eslint-disable import/no-named-as-default-member */ 


var initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: null,
    showOrderbook: true,
    showTabs: false,
    showOrderType: false,
    orderedLot: null,
    orderid: null,
    orderedPrice: null,
    isAutoBuy: false,
    modalData: {},
    onClose: null,
    isDayTrade: false
};
var tradingModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        showModal: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                visible: true
            }, payload));
        },
        setAutoBuy: function(isAutoBuy) {
            set({
                isAutoBuy: isAutoBuy
            });
        },
        resetModal: function() {
            set(initialState);
        },
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        },
        setOrderType: function(type) {
            set({
                orderType: type
            });
        },
        setModalState: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, payload));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (tradingModalStore);


/***/ }),

/***/ 34737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ FLIPT_URL_HOST; },
/* harmony export */   "HZ": function() { return /* binding */ FLIPT_TOKEN; },
/* harmony export */   "Ii": function() { return /* binding */ FLIPT_CHARTBIT_NAMESPACE; },
/* harmony export */   "Vr": function() { return /* binding */ FLIPT_CHARTBIT_TOKEN; },
/* harmony export */   "ad": function() { return /* binding */ FLIPT_NAMESPACE; }
/* harmony export */ });
// Environment variables
var _NEXT_PUBLIC_FLIPT_URL_HOST;
var FLIPT_URL_HOST = (_NEXT_PUBLIC_FLIPT_URL_HOST = "https://flipt.stockbit.com") !== null && _NEXT_PUBLIC_FLIPT_URL_HOST !== void 0 ? _NEXT_PUBLIC_FLIPT_URL_HOST : "";
var _NEXT_PUBLIC_FLIPT_NAMESPACE;
var FLIPT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_NAMESPACE = "transaction") !== null && _NEXT_PUBLIC_FLIPT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_TOKEN;
var FLIPT_TOKEN = (_NEXT_PUBLIC_FLIPT_TOKEN = "3m1ehM_SYRRg0NDWbzixtn4O5ZcVWaaQW7ytx7NAm0A=") !== null && _NEXT_PUBLIC_FLIPT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE;
var FLIPT_CHARTBIT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE = "chartbit") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN;
var FLIPT_CHARTBIT_TOKEN = (_NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN = "N58pKzjn1zMJNwH5pGTOwy3-ufiL1Xdb0VQmRCl5kek=") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN : undefined;


/***/ }),

/***/ 34540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FeatureFlagKeys; }
/* harmony export */ });
/**
 * Flag conventions
 * [platform]-[flag-type]-[feature-name]
 *
 * Platform:
 *   - all: all platform
 *   - android: android only
 *   - ios: ios only
 *   - web: web only
 * Flag Type:
 *   - b: boolean
 *   - v: variant
 * Feature name:
 *   - name of the feature with dash as separator
 *
 * Example:
 *   - web-b-split-order
 *   - all-v-language
 */ var FeatureFlagKeys;
(function(FeatureFlagKeys) {
    FeatureFlagKeys["FR_BONDS"] = "all-b-FR-bonds-eligibility";
    FeatureFlagKeys["SPLIT_ORDER"] = "all-b-split-order-eligibility";
    FeatureFlagKeys["FAST_ORDER"] = "web-b-fast-trade-eligibility";
    FeatureFlagKeys["FAST_ORDER_DUPLICATE_BIDOFFER"] = "web-b-fast-trade-duplicate-bidoffer";
    FeatureFlagKeys["CHARTBIT_MAINTENANCE"] = "chartbit_maintenance";
    FeatureFlagKeys["CHARTBIT_DEBUG"] = "chartbit_debug";
    FeatureFlagKeys["CHARTBIT_DISABLE_AUTOSAVE"] = "chartbit_disable_autosave";
    FeatureFlagKeys["CHARTBIT_IFRAME_LOGGING"] = "chartbit_iframe_logging";
})(FeatureFlagKeys || (FeatureFlagKeys = {}));


/***/ }),

/***/ 62514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ useFliptBoolean; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
;// CONCATENATED MODULE: ./src/lib/flipt/hooks/useFliptBoolean.ts



function useFliptBoolean(flagKey, alwaysLoad, namespaceKey) {
    var featureFlags = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue("featureFlags");
    });
    var loadBooleanEvaluation = (0,useFliptStore/* default */.Z)(function(s) {
        return s.loadBooleanEvaluation;
    });
    var namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : undefined;
    var flag = featureFlags ? featureFlags[flagKey] : undefined;
    (0,react.useEffect)(function() {
        if (flag && !alwaysLoad) {
            return;
        }
        loadBooleanEvaluation(flagKey, namespace);
    }, [
        flagKey,
        flag,
        alwaysLoad
    ]);
    return flag ? flag.isEnabled : false;
};

;// CONCATENATED MODULE: ./src/lib/flipt/hooks/index.ts



/***/ }),

/***/ 90060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_useFliptStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/lib/flipt/constants/endpoints.ts
// endpoints
var endpoints = {
    evaluate: {
        boolean: "evaluate/v1/boolean",
        variant: "evaluate/v1/variant",
        batch: "evaluate/v1/batch"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/lib/flipt/constants/env.ts
var env = __webpack_require__(34737);
;// CONCATENATED MODULE: ./src/lib/flipt/instance.ts




var fliptApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_TOKEN */.HZ) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_TOKEN */.HZ)
        });
    }
    return config;
});
var fliptChartbitApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptChartbitApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_CHARTBIT_TOKEN */.Vr) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_CHARTBIT_TOKEN */.Vr)
        });
    }
    return config;
});

;// CONCATENATED MODULE: ./src/lib/flipt/helpers.ts

var createEntityID = function(userId) {
    return "web-".concat(userId);
};
var createEvaluationPayload = function(userId, flagKey, namespaceKey) {
    return {
        context: {
            user_id: userId
        },
        entityId: createEntityID(userId),
        flagKey: flagKey,
        namespaceKey: namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad
    };
};

;// CONCATENATED MODULE: ./src/lib/flipt/endpoints.ts




var getService = function(service) {
    if (service === "chartbit") {
        return fliptChartbitApi;
    }
    return fliptApi;
};
// endpoints handlers
var evaluateBoolean = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.boolean, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};
var evaluateVariant = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.variant, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};

;// CONCATENATED MODULE: ./src/lib/flipt/store/useFliptStore.ts





var useFliptStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        setUserId: function setUserId(userId) {
            set({
                userId: String(userId)
            });
        },
        loadBooleanEvaluation: function loadBooleanEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, featureFlags, namespace, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            featureFlags = getUIValue("featureFlags");
                            if (!(featureFlags && featureFlags[flagKey])) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", featureFlags[flagKey].isEnabled);
                        case 9:
                            namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : "transaction";
                            _ctx.next = 12;
                            return evaluateBoolean(userId, flagKey, namespace);
                        case 12:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    isEnabled: response.data.enabled
                                };
                            });
                            return _ctx.abrupt("return", response.data.enabled);
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadVariantEvaluation: function loadVariantEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            _ctx.next = 8;
                            return evaluateVariant(userId, flagKey, namespaceKey);
                        case 8:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    variance: response.data
                                };
                            });
                            return _ctx.abrupt("return", response.data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    };
});
/* harmony default export */ var store_useFliptStore = (useFliptStore);


/***/ }),

/***/ 89237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ convertSmartOrderConfigType; },
/* harmony export */   "KH": function() { return /* binding */ convertSecuritiesKind; },
/* harmony export */   "a$": function() { return /* binding */ getExercisedData; },
/* harmony export */   "aF": function() { return /* binding */ getHourFromTimestamp; },
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "y0": function() { return /* binding */ convertBooleanToNumber; },
/* harmony export */   "zn": function() { return /* binding */ convertForceSellEvent; }
/* harmony export */ });
/* unused harmony exports formatToLocalDate, convertGoogleDateToTimestamp */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78343);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91037);


var HOUR_OFFSET = -7;
var convertBooleanToNumber = function(bool) {
    return bool ? 1 : 0;
};
var formatToLocalDate = function(date, customFormat) {
    var adjustedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, HOUR_OFFSET);
    var formattedHour = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(adjustedDate, customFormat);
    return formattedHour;
};
var convertTimestampToDate = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "yyyy-MM-dd HH:mm:ss");
};
var convertGoogleDateToTimestamp = function(date) {
    if (!date) return "";
    var year = date.year, month = date.month, day = date.day;
    var jsDate = new Date(year, month - 1, day + 1);
    return formatToLocalDate(jsDate, "dd-MM-yyyy");
};
var getHourFromTimestamp = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "HH:mm:ss");
};
var getTime = function(timestamp) {
    if (!timestamp) return "";
    return Number(timestamp.seconds) * 1000;
};
var getExercisedData = function(exercise) {
    if (!exercise) return null;
    var active = exercise.active, type = exercise.type, price = exercise.price, info = exercise.info, date = exercise.date;
    return {
        active: active,
        type: type,
        price: price,
        info: info,
        listing_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.listing),
        expired_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.expired),
        mature_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.mature),
        exercise_start_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.start),
        exercise_end_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.end)
    };
};
var convertForceSellEvent = function(event) {
    switch(event){
        case 1:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.DebtRatio */ .pD.DebtRatio;
        case 2:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.TimeLimit */ .pD.TimeLimit;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.Unspecified */ .pD.Unspecified;
    }
};
var convertSmartOrderConfigType = function(configType) {
    switch(configType){
        case "CONFIG_PRICE_TYPE_ABOVE":
            return "1";
        case "CONFIG_PRICE_TYPE_BELOW":
            return "2";
        default:
            return configType;
    }
};
var convertSecuritiesKind = function(kind) {
    switch(kind){
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.STOCK */ .pY.STOCK:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Stock */ .IC.Stock;
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.BOND */ .pY.BOND:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Bond */ .IC.Bond;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Unspecified */ .IC.Unspecified;
    }
};


/***/ }),

/***/ 75413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export convertSideToAction */
/* harmony import */ var utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89237);
/* harmony import */ var global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75626);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91037);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83153);




var convertSideToAction = function(side) {
    return side === global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_2__/* .OrderSide.Buy */ .oU.Buy ? global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .i.Buy : global_Securities_types_api_orderList__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .i.Sell;
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, type = ref.type, info = ref.info, bond = ref.bond, can_create_smart_order = ref.can_create_smart_order, is_sharia = ref.is_sharia;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(flags === null || flags === void 0 ? void 0 : flags.allow_order),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getExercisedData */ .a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.have_smart_order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stock_on_hand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amount_invested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.market_value,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profit_loss,
        type: type !== null && type !== void 0 ? type : "",
        info: info !== null && info !== void 0 ? info : [],
        bond: bond !== null && bond !== void 0 ? bond : undefined,
        show_create_smartorder: can_create_smart_order !== null && can_create_smart_order !== void 0 ? can_create_smart_order : false,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.can_buy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.can_sell,
        is_sharia: is_sharia
    };
};
var portfolioItemFromBonds = function(data) {
    var ref, ref1, ref2, ref3;
    return {
        allow_order: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(true),
        amount_invested: data === null || data === void 0 ? void 0 : data.invested_amount,
        available_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        available_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_lot: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        balance_share: parseInt(data === null || data === void 0 ? void 0 : data.total_units, 10),
        company_name: data.product.name,
        exercise_data: undefined,
        exercise_type: undefined,
        have_smartorder: false,
        price_average: data === null || data === void 0 ? void 0 : data.price_rate,
        price_average_fee: data === null || data === void 0 ? void 0 : data.price_rate,
        price_latest: undefined,
        stock_on_hand: data === null || data === void 0 ? void 0 : data.invested_amount,
        symbol: data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.identifier,
        total: data === null || data === void 0 ? void 0 : data.total_portfolio,
        unrealised_gain: (data === null || data === void 0 ? void 0 : (ref1 = data.profit_loss) === null || ref1 === void 0 ? void 0 : ref1.percentage) / 100,
        unrealised_marketvalue: data === null || data === void 0 ? void 0 : data.market_value,
        unrealised_profitloss: data === null || data === void 0 ? void 0 : (ref2 = data.profit_loss) === null || ref2 === void 0 ? void 0 : ref2.amount,
        type: constants_trading__WEBPACK_IMPORTED_MODULE_3__/* .STOCK_TYPE.bond */ .L2.bond,
        info: undefined,
        bond: undefined,
        show_create_smartorder: false,
        bond_sell_enabled: parseInt(data === null || data === void 0 ? void 0 : data.units, 10) > 0,
        is_sharia: data === null || data === void 0 ? void 0 : (ref3 = data.product) === null || ref3 === void 0 ? void 0 : ref3.is_sharia,
        can_buy: false,
        can_sell: false
    };
};
var portfolioList = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref.summary, smart_order_info = ref.smart_order_info, stockPortfolios = ref.results, day_trade = ref.day_trade;
    var result = stockPortfolios.map(function(stockPortfolio) {
        return portfolioItem(stockPortfolio);
    });
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : summary.trading.balance,
        amount_allocated: summary === null || summary === void 0 ? void 0 : summary.amount.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : summary.amount.credit_limit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.realised,
        show_create_smartorder: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.can_create,
        auto_order_info: smart_order_info === null || smart_order_info === void 0 ? void 0 : smart_order_info.info,
        day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.map(function(item) {
            return portfolioItem(item);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : summary.debt.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : summary.debt.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : summary.debt.market_value,
        amount_invested: summary === null || summary === void 0 ? void 0 : summary.amount.invested,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        profitloss: summary === null || summary === void 0 ? void 0 : summary.profit_loss.net,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        result: result
    };
};
var orderDetail = function(order) {
    var ref;
    var ref1 = order !== null && order !== void 0 ? order : {}, action = ref1.action, amount = ref1.amount, day_trade = ref1.day_trade, gtc = ref1.gtc, market_order_id = ref1.market_order_id, message = ref1.message, order_id = ref1.order_id, price = ref1.price, qty = ref1.qty, side = ref1.side, securities_kind = ref1.securities_kind, smart_order = ref1.smart_order, status_text = ref1.status_text, symbol = ref1.symbol, time = ref1.time, is_sharia = ref1.is_sharia;
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    var ref2, ref3, ref4, ref5, ref6;
    return {
        action: convertSideToAction(side),
        amend_action: action === null || action === void 0 ? void 0 : action.can_amend,
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: isBond ? undefined : amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matched_total,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_action: action === null || action === void 0 ? void 0 : action.can_cancel,
        config_type: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertSmartOrderConfigType */ .Hc)(smart_order === null || smart_order === void 0 ? void 0 : smart_order.config_type),
        gtc: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertBooleanToNumber */ .y0)(gtc === null || gtc === void 0 ? void 0 : gtc.is_gtc),
        label: smart_order === null || smart_order === void 0 ? void 0 : smart_order.label,
        market_orderid: market_order_id,
        message: message,
        order_done: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_done,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lot_open,
        order_total: isBond ? undefined : qty === null || qty === void 0 ? void 0 : qty.lot_total,
        orderid: order_id,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_average_portfolio: price === null || price === void 0 ? void 0 : price.average.portfolio,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: (ref2 = smart_order === null || smart_order === void 0 ? void 0 : smart_order.order_id) !== null && ref2 !== void 0 ? ref2 : smart_order === null || smart_order === void 0 ? void 0 : smart_order.id,
        status: status_text,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .getHourFromTimestamp */ .aF)((ref3 = time === null || time === void 0 ? void 0 : time.open) !== null && ref3 !== void 0 ? ref3 : time === null || time === void 0 ? void 0 : time.opened_at),
        time_match: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref4 = time === null || time === void 0 ? void 0 : time.match) !== null && ref4 !== void 0 ? ref4 : time === null || time === void 0 ? void 0 : time.matched_at),
        time_open: (0,utils_securities_formatter__WEBPACK_IMPORTED_MODULE_0__/* .convertTimestampToDate */ .gg)((ref5 = time === null || time === void 0 ? void 0 : time.open) !== null && ref5 !== void 0 ? ref5 : time === null || time === void 0 ? void 0 : time.opened_at),
        trigger_price: smart_order === null || smart_order === void 0 ? void 0 : smart_order.trigger_price,
        day_trade_is_day_trade: day_trade === null || day_trade === void 0 ? void 0 : day_trade.is_day_trade,
        day_trade_force_sell_event: day_trade === null || day_trade === void 0 ? void 0 : day_trade.force_sell_event,
        day_trade_message: (ref6 = day_trade === null || day_trade === void 0 ? void 0 : day_trade.message) !== null && ref6 !== void 0 ? ref6 : "",
        is_sharia: is_sharia
    };
};
var orderList = function(orders) {
    var mappedData = orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    });
    return mappedData;
};
var formulaData = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, version = ref.version, formula = ref.formula, fee = ref.fee, preview_fee = ref.preview_fee, day_trade = ref.day_trade;
    var dayTradePreviewFee = (day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee) ? day_trade.preview_fee : preview_fee;
    return {
        version: version,
        fee: {
            buy: fee.buy,
            sell: fee.sell
        },
        formula: {
            buy_amount_broker_fee: formula.buy.broker_fee,
            buy_amount_exchange_fee: formula.buy.exchange_fee,
            buy_amount_fee: formula.buy.fee,
            buy_amount_invested: formula.buy.invested,
            buy_amount_invested_fee: formula.buy.invested_fee,
            ca_sell_amount_broker_fee: formula.ca_sell.broker_fee,
            ca_sell_amount_exchange_fee: formula.ca_sell.exchange_fee,
            ca_sell_amount_fee: formula.ca_sell.fee,
            ca_sell_amount_invested: formula.ca_sell.invested,
            ca_sell_amount_invested_fee: formula.ca_sell.invested_fee,
            sell_amount_broker_fee: formula.sell.broker_fee,
            sell_amount_exchange_fee: formula.sell.exchange_fee,
            sell_amount_fee: formula.sell.fee,
            sell_amount_invested: formula.sell.invested,
            sell_amount_invested_fee: formula.sell.invested_fee,
            sell_gain: formula.sell_gain,
            sell_profit_loss: formula.sell_profit_loss,
            amount_invested: formula.amount_invested,
            summary_equity: formula.summary.equity,
            summary_invested: formula.summary.invested,
            summary_net_profit_loss: formula.summary.net_profit_loss.value,
            summary_net_profit_loss_percentage: formula.summary.net_profit_loss.percentage,
            unrealised_gain: formula.unrealized.gain,
            unrealised_market_value: formula.unrealized.market_value,
            unrealised_profit_loss: formula.unrealized.profit_loss,
            day_trade_debt_ratio: formula.day_trade.debt.ratio,
            day_trade_debt_unrealized: formula.day_trade.debt.unrealized,
            day_trade_portion_order_amount: formula.day_trade.portion_order_amount,
            day_trade_investment_day_trade: formula.day_trade.investment.day_trade,
            day_trade_investment_portion_tb: formula.day_trade.investment.portion_tb,
            fee_buy: fee.buy,
            fee_sell: fee.sell,
            fee_buy_day_trade: day_trade.fee.buy,
            fee_sell_day_trade: day_trade.fee.sell
        },
        preview_fee: {
            broker_fee: preview_fee.broker_fee,
            exchange: {
                compositions: preview_fee.exchange.compositions,
                title: preview_fee.exchange.title,
                desc: preview_fee.exchange.desc,
                subtitle: preview_fee.exchange.subtitle,
                exchange_fee_total_buy: preview_fee.exchange.total_buy,
                exchange_fee_total_ca_buy: preview_fee.exchange.total_ca_buy,
                exchange_fee_total_ca_sell: preview_fee.exchange.total_ca_sell,
                exchange_fee_total_sell: preview_fee.exchange.total_sell,
                exchange_fee_total_title: preview_fee.exchange.total_title
            }
        },
        day_trade: {
            fee: {
                buy: day_trade.fee.buy,
                sell: day_trade.fee.sell
            },
            portion_deduct_to_tb: day_trade.portion_deduct_to_tb,
            preview_fee: {
                broker_fee: dayTradePreviewFee.broker_fee,
                exchange: {
                    compositions: dayTradePreviewFee.exchange.compositions,
                    title: dayTradePreviewFee.exchange.title,
                    desc: dayTradePreviewFee.exchange.desc,
                    subtitle: dayTradePreviewFee.exchange.subtitle,
                    exchange_fee_total_buy: dayTradePreviewFee.exchange.total_buy,
                    exchange_fee_total_ca_buy: dayTradePreviewFee.exchange.total_ca_buy,
                    exchange_fee_total_ca_sell: dayTradePreviewFee.exchange.total_ca_sell,
                    exchange_fee_total_sell: dayTradePreviewFee.exchange.total_sell,
                    exchange_fee_total_title: dayTradePreviewFee.exchange.total_title
                }
            }
        }
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList,
    formulaData: formulaData,
    portfolioItemFromBonds: portfolioItemFromBonds
});


/***/ })

}]);